var map = {
	"./application.svg": "07e6",
	"./calendar.svg": "9776",
	"./clinic.svg": "5092",
	"./doctor.svg": "82a5",
	"./health-managers.svg": "9f1b",
	"./home.svg": "647e",
	"./inbox.svg": "f4bd",
	"./patient.svg": "2d76",
	"./report.svg": "5b72",
	"./reviews.svg": "c844",
	"./skyadoctor.svg": "7411",
	"./star.svg": "7e16",
	"./surveys.svg": "3312",
	"./treatment.svg": "6e72"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1310";